export default __webpack_public_path__ + "static/media/award-1.45988c18.svg";